import { Button, Dialog } from '@/components/DesignSystem';
import { PromotionCard } from '@/pages/Product/PromotionCard';
import { PromotionDetailsModal } from '@/pages/Promotions/PromotionDetailsModal';
import { ApiPromotion } from '@api/interfaces';
import { Stack } from '@mui/material';
import { sortBy } from 'lodash';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface ProductPromotionsModalProps {
  onClose: () => void,
  promotions: ApiPromotion[],
}

export const ProductPromotionsModal = ({
  onClose,
  promotions,
}: ProductPromotionsModalProps) => {
  const { t } = useTranslation();
  const [selectedPromotion, setSelectedPromotion] = useState<ApiPromotion | null>(null);

  const sortedPromotions = sortBy(promotions, 'endDate');

  return (
    <>
      <Dialog
        acceptButton={(props) => (
          <Button {...props} onClick={onClose} sx={{ width: '84px' }} variant="contained">
            {t($ => $.common.actions.close)}
          </Button>
        )}
        contentSx={{ pb: '16px' }}
        onClose={onClose}
        open
        showCloseButton={false}
        subtitle={t($ => $.products.promotionsModal.subtitle)}
        testID="product-promotions-modal"
        title={t($ => $.products.promotionsModal.title)}
      >
        <Stack gap="16px">
          {sortedPromotions.map((promotion) => (
            <PromotionCard
              key={promotion.id}
              onClickDetails={() => setSelectedPromotion(promotion)}
              promotion={promotion}
            />
          ))}
        </Stack>
      </Dialog>
      {!!selectedPromotion && (
        <PromotionDetailsModal
          onBack={() => setSelectedPromotion(null)}
          onClose={onClose}
          promotionId={selectedPromotion.id}
        />
      )}
    </>
  );
};
